import styled from 'styled-components';
const ButtonStyle = styled.div `
	--core_btnPadTB: var(--sp2x);
	--core_btnPadLR: var(--sp3x);
	--core_btnBorderRadius: var(--sp5x);

	&.btn {
		width: fit-content;
		overflow: hidden;
		cursor: pointer;

		a,
		button {
			display: flex;
			align-items: center;
			justify-content: center;
			text-align: center;
			padding: var(--core_btnPadTB) var(--core_btnPadLR);
			font-size: var(--sp3x);
			font-family: var(--core_Font);
			font-weight: 400;
			border: 1px solid var(--core_black);
			background-color: var(--core_white);
			color: var(--core_black);
			border-radius: var(--core_btnBorderRadius);
			transition:
				color var(--core_trTime) ease-out,
				background-color var(--core_trTime) ease-out,
				border-color var(--core_trTime) ease-out;
			cursor: pointer;

			@media (pointer: fine) {
				@media (hover: hover) {
					&:hover {
						border: 1px solid var(--core_white);
						background-color: var(--core_black);
						color: var(--core_white);
					}
				}
			}
		}

		&.disabled {
			pointer-events: none;

			a,
			button {
				opacity: 0.5;
				pointer-events: none;
			}
		}
	}
`;
export default ButtonStyle;
//# sourceMappingURL=style.js.map